enum SampleBranding {

    STANDARD = 'STANDARD',
    MANUFAKTUR = 'MANUFAKTUR',
    MANUFAKTUR_EXCLUSIVE = 'MANUFAKTUR_EXCLUSIVE',
}

export default SampleBranding;